import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import classNames from 'classnames';
import Button from 'carbon-react/lib/components/button';

import { ROUTES, getForecastByIdOnboardingUrl } from '@futrli/shared-services';

import * as styles from '../forecasting-onboarding.scss';
import { OnboardingPageTitle } from '../components/onboarding-page-title';
import { OnboardingPredictionsRouter } from '../components/onboarding-predictions-router';
import historicalData from '../arrows/historical-data.png';
import historicalDataRight from '../arrows/historical-data-right.png';
import {
  LS_FORECASTING_ONBOARDING_STEP,
  SCENARIO_ONBOARDING_STEP,
  SCENARIO_WITH_INVOICES_ONBOARDING_STEP
} from '../const';
import { useAnimationLatency, useOnboardingUrlInfo } from '../utils/hooks';
import { ForecastType } from '../shared/onboarding-type-select';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';

export const OnboardingHistoricalData = () => {
  const navigate = useNavigate();
  const { forecast, turnOffPredictionsExplanations } = usePredictionsInfoContext();
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();

  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisationId || '';

  const { forecastType, isOnboardingScenarioRoute, isOnboardingScenarioWithInvoicesRoute } = useOnboardingUrlInfo();

  useEffect(() => {
    turnOffPredictionsExplanations?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showAnimatedArrows = useAnimationLatency(true);

  const handleNextClick = () => {
    if (!forecast) {
      return;
    }

    let nextStep;
    if (isOnboardingScenarioRoute) {
      nextStep =
        forecastType === ForecastType.FromScratch
          ? SCENARIO_ONBOARDING_STEP.SCRATCH_CONTROL_WHAT_YOU_SEE
          : forecastType === ForecastType.WithAutoPredictions
          ? SCENARIO_ONBOARDING_STEP.AUTO_PREDICTIONS_WHAT_YOU_SEE
          : SCENARIO_ONBOARDING_STEP.LYA_CONTROL_WHAT_YOU_SEE;
    } else {
      nextStep =
        forecastType === ForecastType.FromScratch
          ? SCENARIO_WITH_INVOICES_ONBOARDING_STEP.SCRATCH_CONTROL_WHAT_YOU_SEE
          : forecastType === ForecastType.WithAutoPredictions
          ? SCENARIO_WITH_INVOICES_ONBOARDING_STEP.AUTO_PREDICTIONS_WHAT_YOU_SEE
          : SCENARIO_WITH_INVOICES_ONBOARDING_STEP.LYA_CONTROL_WHAT_YOU_SEE;
    }

    navigate(
      `${getForecastByIdOnboardingUrl(
        workspaceId,
        organisationId,
        forecast.id,
        false,
        isOnboardingScenarioWithInvoicesRoute
      )}/${nextStep}${ROUTES.SALES}${location.search}`
    );
    localStorage.setItem(LS_FORECASTING_ONBOARDING_STEP, nextStep);
  };

  return (
    <div className={styles.contentContainer} style={{ position: 'relative' }}>
      <img
        alt="onboarding-arrow"
        src={historicalData}
        style={{ position: 'absolute', left: 490, top: 72, zIndex: 13 }}
        className={classNames(styles.fadeInContainer, {
          [styles.fadeIn]: showAnimatedArrows
        })}
      />
      <img
        alt="onboarding-arrow"
        src={historicalDataRight}
        style={{ position: 'absolute', right: 94, top: 72, zIndex: 13 }}
        className={classNames(styles.fadeInContainer, {
          [styles.fadeIn]: showAnimatedArrows
        })}
      />
      <OnboardingPageTitle
        title={
          <FormattedMessage
            id="onboarding.2_fin_year_historical_3_year_future"
            defaultMessage="You have 2 financial years of historical data and a 3 year cash flow future outlook..."
          />
        }
        description={
          <FormattedMessage
            id="onboarding.important_for_reporting"
            defaultMessage="This is important when you want to use this data for reporting."
          />
        }
      />
      <Button disabled={!forecast} mb="30px" buttonType="primary" size="large" onClick={handleNextClick}>
        <FormattedMessage id="common.next" defaultMessage="Next" />
      </Button>
      <OnboardingPredictionsRouter />
    </div>
  );
};
